import { Card } from '@/components/ui/card'
import type { ReactNode } from 'react'
import type { Icon } from '@phosphor-icons/react'

interface MetricSectionProps {
  title: string
  icon?: Icon
  count?: number
  children: ReactNode
}

export function MetricSection({ title, icon: IconComp, count, children }: MetricSectionProps) {
  return (
    <Card className="bg-card border border-border rounded-2xl overflow-hidden">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-border/60">
        <div className="flex items-center gap-2">
          {IconComp && <IconComp weight="regular" className="w-3.5 h-3.5 text-muted-foreground" />}
          <span className="text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">
            {title}
          </span>
        </div>
        {count !== undefined && (
          <span className="text-[10px] text-muted-foreground/60">{count} métricas</span>
        )}
      </div>
      <div className="px-4 py-1">{children}</div>
    </Card>
  )
}
